var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tmp-block",style:({ height: _vm.height ? (_vm.height + "px") : '100%', width: _vm.width ? (_vm.width + "px") : '100%' })})}
var staticRenderFns = []

export { render, staticRenderFns }